import Swup from "swup";
import SwupA11yPlugin from "@swup/a11y-plugin";

export const swup = new Swup({
    plugins: [new SwupA11yPlugin()],
    linkToSelf: "navigate",
});
